import moment from 'moment';
import { dateFormat } from '../common/constant';

export const transformPro = (data, isBusineesPartner?) => {
    const userApiData: any[] = [];
    data?.map((eachObject) => {
        if (isBusineesPartner) {
            eachObject.stringPartnerType = eachObject.partnerType == 1 ? 'Buyer' : 'Supplier';
        }
        userApiData.push({ ...eachObject, 'key': eachObject['_id'] });
    })
    return userApiData;
}

export const transformEachApiDataKeyValue = (data, rowKey: string) => {
    let userApiData: any[] = [];
    data?.map(
        (eachRowData) => {
            if (!eachRowData.isDeleted) {
                userApiData.push({ 'key': eachRowData['_id'], 'value': eachRowData[rowKey] })
            }
        }
    )
    return userApiData;
}

export const transformPFi = (data,showDeletedData, isPurchaseOrder = false, isCommercialInvoice = false) => {
    const tableRowdata: any[] = [];
    for (let userkey in data) {
        data[userkey]?.map((eachInvoiceData) => {
            if(showDeletedData) {
                if (eachInvoiceData.isDeleted) {
                    tableRowdata.push({
                        key: eachInvoiceData['_id'],
                        // buyerName: eachInvoiceData.buyer?.name,
                        reasonToDelete: eachInvoiceData.reasonToDelete,
                        poNumber: isCommercialInvoice ? eachInvoiceData.poNumber?.poNumber : '',
                        date: eachInvoiceData.updatedAt ? moment(+eachInvoiceData.updatedAt).format(dateFormat) : '',
                        dateNumber: eachInvoiceData.updatedAt,
                        invoiceNumber: isPurchaseOrder ? eachInvoiceData.poNumber : eachInvoiceData.invoiceNumber,
                        exporterRefNo: isPurchaseOrder ? eachInvoiceData.invoiceNumber.invoiceNumber
                            : isCommercialInvoice ? eachInvoiceData.otherReferences.invoiceNumber : eachInvoiceData.exporterRefNo?.invoiceNumber
                    });
                }
            } else {
                if (!eachInvoiceData.isDeleted) {
                    tableRowdata.push({
                        key: eachInvoiceData['_id'],
                        buyerName: eachInvoiceData.buyer?.name,
                        poNumber: isCommercialInvoice ? eachInvoiceData.poNumber?.poNumber : '',
                        date: eachInvoiceData.updatedAt ? moment(+eachInvoiceData.updatedAt).format(dateFormat) : '',
                        dateNumber: eachInvoiceData.updatedAt,
                        invoiceNumber: isPurchaseOrder ? eachInvoiceData.poNumber : eachInvoiceData.invoiceNumber,
                        exporterRefNo: isPurchaseOrder ? eachInvoiceData.invoiceNumber.invoiceNumber
                            : isCommercialInvoice ? eachInvoiceData.otherReferences.invoiceNumber : eachInvoiceData.exporterRefNo?.invoiceNumber
                    });
                }
            }
        });
    }
    return tableRowdata;
}

